module.exports = __webpack_public_path__ + "static/media/ppt.25860965.png";